// extracted by mini-css-extract-plugin
export var cartContainer = "_kb-4";
export var gray = "_kb-1";
export var itemContainer = "_kb-2";
export var itemDetails = "_kb-3";
export var strong = "_kb-0";